import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  tr: {
    // Navigation
    home: 'Ana Sayfa',
    menu: 'Menü',
    alakart: 'A La Carte',
    catering: 'Günlük Menü',
    cart: 'Sepet',
    orders: 'Siparişlerim',
    profile: 'Profilim',
    login: 'Giriş Yap',
    logout: 'Çıkış Yap',
    register: 'Kayıt Ol',
    
    // Home
    welcome: 'Hoş Geldiniz',
    heroTitle: 'Lezzetin Adresi',
    heroSubtitle: 'Taze malzemeler, özenle hazırlanmış yemekler',
    orderNow: 'Sipariş Ver',
    viewMenu: 'Menüyü Gör',
    contactUs: 'İletişim',
    address: 'Adres',
    phone: 'Telefon',
    
    // Menu
    search: 'Ara',
    searchPlaceholder: 'Yemek ara...',
    allCategories: 'Tümü',
    addToCart: 'Sepete Ekle',
    added: 'Eklendi',
    outOfStock: 'Tükendi',
    inStock: 'adet',
    
    // Cart
    yourCart: 'Sepetiniz',
    emptyCart: 'Sepetiniz boş',
    subtotal: 'Ara Toplam',
    discount: 'İndirim',
    total: 'Toplam',
    checkout: 'Siparişi Tamamla',
    couponCode: 'Kupon Kodu',
    applyCoupon: 'Uygula',
    removeCoupon: 'Kaldır',
    
    // Checkout
    deliveryAddress: 'Teslimat Adresi',
    paymentMethod: 'Ödeme Yöntemi',
    cash: 'Nakit',
    card: 'Kredi Kartı',
    orderNotes: 'Sipariş Notu',
    confirmOrder: 'Siparişi Onayla',
    tableOrder: 'Masa Siparişi',
    table: 'Masa',
    
    // Orders
    myOrders: 'Siparişlerim',
    orderStatus: 'Sipariş Durumu',
    preparing: 'Hazırlanıyor',
    onTheWay: 'Yolda',
    delivered: 'Teslim Edildi',
    orderDate: 'Sipariş Tarihi',
    orderDetails: 'Sipariş Detayı',
    
    // Auth
    email: 'E-posta',
    password: 'Şifre',
    name: 'İsim',
    phoneNumber: 'Telefon Numarası',
    alreadyHaveAccount: 'Zaten hesabınız var mı?',
    dontHaveAccount: 'Hesabınız yok mu?',
    
    // Catering
    dailyMenu: 'Günlük Menü',
    cateringInfo: 'Her 4 Kap Yemek = €10',
    cateringDesc: 'Her 4 kategoriden 1er tane = €10. 2ser = €20. Ayni kategoriden ekstra = urun fiyati. 4ten az = bireysel fiyat.',
    persons: 'Kişi',
    selected: 'seçili',
    extra: 'ekstra',
    
    // Common
    loading: 'Yükleniyor...',
    error: 'Hata oluştu',
    success: 'Başarılı',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    close: 'Kapat',
    yes: 'Evet',
    no: 'Hayır',
    
    // Footer
    enjoyYourMeal: 'AFİYET OLSUN!',
    
    // Layout Menu
    loyaltyPoints: 'Sadakat Puanı',
    loyaltyProgram: 'Sadakat Programı',
    account: 'Hesap',
    beverages: 'İçecekler',
  },
  
  en: {
    // Navigation
    home: 'Home',
    menu: 'Menu',
    alakart: 'A La Carte',
    catering: 'Daily Menu',
    cart: 'Cart',
    orders: 'My Orders',
    profile: 'Profile',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    
    // Home
    welcome: 'Welcome',
    heroTitle: 'Taste of Excellence',
    heroSubtitle: 'Fresh ingredients, carefully prepared dishes',
    orderNow: 'Order Now',
    viewMenu: 'View Menu',
    contactUs: 'Contact',
    address: 'Address',
    phone: 'Phone',
    
    // Menu
    search: 'Search',
    searchPlaceholder: 'Search dishes...',
    allCategories: 'All',
    addToCart: 'Add to Cart',
    added: 'Added',
    outOfStock: 'Out of Stock',
    inStock: 'pcs',
    
    // Cart
    yourCart: 'Your Cart',
    emptyCart: 'Your cart is empty',
    subtotal: 'Subtotal',
    discount: 'Discount',
    total: 'Total',
    checkout: 'Checkout',
    couponCode: 'Coupon Code',
    applyCoupon: 'Apply',
    removeCoupon: 'Remove',
    
    // Checkout
    deliveryAddress: 'Delivery Address',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    card: 'Credit Card',
    orderNotes: 'Order Notes',
    confirmOrder: 'Confirm Order',
    tableOrder: 'Table Order',
    table: 'Table',
    
    // Orders
    myOrders: 'My Orders',
    orderStatus: 'Order Status',
    preparing: 'Preparing',
    onTheWay: 'On the Way',
    delivered: 'Delivered',
    orderDate: 'Order Date',
    orderDetails: 'Order Details',
    
    // Auth
    email: 'Email',
    password: 'Password',
    name: 'Name',
    phoneNumber: 'Phone Number',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    
    // Catering
    dailyMenu: 'Daily Menu',
    cateringInfo: 'Every 4 Dishes = €10',
    cateringDesc: '1 from each of 4 categories = €10. 2 each = €20. Same category extras = item price. Under 4 = individual prices.',
    persons: 'Persons',
    selected: 'selected',
    extra: 'extra',
    
    // Common
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    
    // Footer
    enjoyYourMeal: 'ENJOY YOUR MEAL!',
    
    // Layout Menu
    loyaltyPoints: 'Loyalty Points',
    loyaltyProgram: 'Loyalty Program',
    account: 'Account',
    beverages: 'Beverages',
  },
  
  me: {
    // Navigation
    home: 'Početna',
    menu: 'Meni',
    alakart: 'A La Carte',
    catering: 'Dnevni Meni',
    cart: 'Korpa',
    orders: 'Moje Narudžbe',
    profile: 'Profil',
    login: 'Prijava',
    logout: 'Odjava',
    register: 'Registracija',
    
    // Home
    welcome: 'Dobrodošli',
    heroTitle: 'Ukus Izvrsnosti',
    heroSubtitle: 'Svježi sastojci, pažljivo pripremljena jela',
    orderNow: 'Naruči Sada',
    viewMenu: 'Pogledaj Meni',
    contactUs: 'Kontakt',
    address: 'Adresa',
    phone: 'Telefon',
    
    // Menu
    search: 'Pretraži',
    searchPlaceholder: 'Pretraži jela...',
    allCategories: 'Sve',
    addToCart: 'Dodaj u Korpu',
    added: 'Dodato',
    outOfStock: 'Nema na stanju',
    inStock: 'kom',
    
    // Cart
    yourCart: 'Vaša Korpa',
    emptyCart: 'Korpa je prazna',
    subtotal: 'Međuzbir',
    discount: 'Popust',
    total: 'Ukupno',
    checkout: 'Završi Narudžbu',
    couponCode: 'Kupon Kod',
    applyCoupon: 'Primijeni',
    removeCoupon: 'Ukloni',
    
    // Checkout
    deliveryAddress: 'Adresa Dostave',
    paymentMethod: 'Način Plaćanja',
    cash: 'Gotovina',
    card: 'Kreditna Kartica',
    orderNotes: 'Napomena',
    confirmOrder: 'Potvrdi Narudžbu',
    tableOrder: 'Narudžba za Sto',
    table: 'Sto',
    
    // Orders
    myOrders: 'Moje Narudžbe',
    orderStatus: 'Status Narudžbe',
    preparing: 'Priprema se',
    onTheWay: 'Na putu',
    delivered: 'Dostavljeno',
    orderDate: 'Datum Narudžbe',
    orderDetails: 'Detalji Narudžbe',
    
    // Auth
    email: 'E-mail',
    password: 'Lozinka',
    name: 'Ime',
    phoneNumber: 'Broj Telefona',
    alreadyHaveAccount: 'Već imate nalog?',
    dontHaveAccount: 'Nemate nalog?',
    
    // Catering
    dailyMenu: 'Dnevni Meni',
    cateringInfo: 'Svaka 4 Jela = €10',
    cateringDesc: '1 iz svake od 4 kategorije = €10. Po 2 = €20. Dodatni artikli = cijena. Manje od 4 = pojedinacne cijene.',
    persons: 'Osoba',
    selected: 'odabrano',
    extra: 'dodatno',
    
    // Common
    loading: 'Učitavanje...',
    error: 'Došlo je do greške',
    success: 'Uspješno',
    save: 'Sačuvaj',
    cancel: 'Otkaži',
    delete: 'Obriši',
    edit: 'Uredi',
    close: 'Zatvori',
    yes: 'Da',
    no: 'Ne',
    
    // Footer
    enjoyYourMeal: 'PRIJATNO!',
    
    // Layout Menu
    loyaltyPoints: 'Poeni Lojalnosti',
    loyaltyProgram: 'Program Lojalnosti',
    account: 'Nalog',
    beverages: 'Pića',
  },

  ru: {
    home: 'Главная',
    menu: 'Меню',
    alakart: 'А Ла Карт',
    catering: 'Дневное Меню',
    cart: 'Корзина',
    orders: 'Мои Заказы',
    profile: 'Профиль',
    login: 'Войти',
    logout: 'Выйти',
    register: 'Регистрация',
    welcome: 'Добро пожаловать',
    heroTitle: 'Вкус Изысканности',
    heroSubtitle: 'Свежие ингредиенты, блюда с заботой',
    orderNow: 'Заказать',
    viewMenu: 'Смотреть Меню',
    contactUs: 'Контакты',
    address: 'Адрес',
    phone: 'Телефон',
    search: 'Поиск',
    searchPlaceholder: 'Поиск блюд...',
    allCategories: 'Все',
    addToCart: 'В Корзину',
    added: 'Добавлено',
    outOfStock: 'Нет в наличии',
    inStock: 'шт',
    yourCart: 'Ваша Корзина',
    emptyCart: 'Корзина пуста',
    subtotal: 'Промежуточный итог',
    discount: 'Скидка',
    total: 'Итого',
    checkout: 'Оформить Заказ',
    couponCode: 'Промокод',
    applyCoupon: 'Применить',
    removeCoupon: 'Удалить',
    deliveryAddress: 'Адрес Доставки',
    paymentMethod: 'Способ Оплаты',
    cash: 'Наличные',
    card: 'Кредитная Карта',
    orderNotes: 'Примечание',
    confirmOrder: 'Подтвердить Заказ',
    tableOrder: 'Заказ за Столом',
    table: 'Стол',
    myOrders: 'Мои Заказы',
    orderStatus: 'Статус Заказа',
    preparing: 'Готовится',
    onTheWay: 'В Пути',
    delivered: 'Доставлено',
    orderDate: 'Дата Заказа',
    orderDetails: 'Детали Заказа',
    email: 'Эл. почта',
    password: 'Пароль',
    name: 'Имя',
    phoneNumber: 'Номер телефона',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    dontHaveAccount: 'Нет аккаунта?',
    dailyMenu: 'Дневное Меню',
    cateringInfo: 'Любые 4 Блюда = €10',
    cateringDesc: '1 из 4 категорий = €10. По 2 = €20. Дополнительные = по цене. Меньше 4 = индивидуальные цены.',
    persons: 'чел',
    selected: 'выбрано',
    extra: 'дополнительно',
    loading: 'Загрузка...',
    error: 'Произошла ошибка',
    success: 'Успешно',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Изменить',
    close: 'Закрыть',
    yes: 'Да',
    no: 'Нет',
    enjoyYourMeal: 'ПРИЯТНОГО АППЕТИТА!',
    loyaltyPoints: 'Бонусные Баллы',
    loyaltyProgram: 'Программа Лояльности',
    account: 'Аккаунт',
    beverages: 'Напитки',
  },

  sr: {
    home: 'Почетна',
    menu: 'Мени',
    alakart: 'А Ла Карт',
    catering: 'Дневни Мени',
    cart: 'Корпа',
    orders: 'Моје Поруџбине',
    profile: 'Профил',
    login: 'Пријава',
    logout: 'Одјава',
    register: 'Регистрација',
    welcome: 'Добродошли',
    heroTitle: 'Укус Изврсности',
    heroSubtitle: 'Свежи састојци, пажљиво припремљена јела',
    orderNow: 'Наручи Сада',
    viewMenu: 'Погледај Мени',
    contactUs: 'Контакт',
    address: 'Адреса',
    phone: 'Телефон',
    search: 'Претражи',
    searchPlaceholder: 'Претражи јела...',
    allCategories: 'Све',
    addToCart: 'Додај у Корпу',
    added: 'Додато',
    outOfStock: 'Нема на стању',
    inStock: 'ком',
    yourCart: 'Ваша Корпа',
    emptyCart: 'Корпа је празна',
    subtotal: 'Међузбир',
    discount: 'Попуст',
    total: 'Укупно',
    checkout: 'Заврши Поруџбину',
    couponCode: 'Купон Код',
    applyCoupon: 'Примени',
    removeCoupon: 'Уклони',
    deliveryAddress: 'Адреса Доставе',
    paymentMethod: 'Начин Плаћања',
    cash: 'Готовина',
    card: 'Кредитна Картица',
    orderNotes: 'Напомена',
    confirmOrder: 'Потврди Поруџбину',
    tableOrder: 'Поруџбина за Сто',
    table: 'Сто',
    myOrders: 'Моје Поруџбине',
    orderStatus: 'Статус Поруџбине',
    preparing: 'Припрема се',
    onTheWay: 'На путу',
    delivered: 'Достављено',
    orderDate: 'Датум Поруџбине',
    orderDetails: 'Детаљи Поруџбине',
    email: 'Е-пошта',
    password: 'Лозинка',
    name: 'Име',
    phoneNumber: 'Број Телефона',
    alreadyHaveAccount: 'Већ имате налог?',
    dontHaveAccount: 'Немате налог?',
    dailyMenu: 'Дневни Мени',
    cateringInfo: 'Свака 4 Јела = €10',
    cateringDesc: '1 из сваке од 4 категорије = €10. По 2 = €20. Додатни артикли = цена. Мање од 4 = појединачне цене.',
    persons: 'Особа',
    selected: 'одабрано',
    extra: 'додатно',
    loading: 'Учитавање...',
    error: 'Дошло је до грешке',
    success: 'Успешно',
    save: 'Сачувај',
    cancel: 'Откажи',
    delete: 'Обриши',
    edit: 'Уреди',
    close: 'Затвори',
    yes: 'Да',
    no: 'Не',
    enjoyYourMeal: 'ПРИЈАТНО!',
    loyaltyPoints: 'Поени Лојалности',
    loyaltyProgram: 'Програм Лојалности',
    account: 'Налог',
    beverages: 'Пића',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'tr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  const languages = [
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'me', name: 'Crnogorski', flag: '🇲🇪' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'sr', name: 'Српски', flag: '🇷🇸' }
  ];

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
